import { MutationTree } from 'vuex'
import { IMessageState } from '@/store/message'
import { Types, Store, Current, Filter } from '@/store/message/types'

const mutations: MutationTree<IMessageState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.filter]: (state, action: Filter) => {
    state.filter = action.payload
  }
}

export default mutations
